// @flow

import React from 'react';

import { DEADLINE_TRANSLATE_PREFIX } from 'routes/cart/components/deadline/DeadlineWarning';
import { StyledDeadlineTranslate } from 'routes/cart/components/shared';

type Props = {
  isFFM: boolean,
  onExchange: boolean,
  using: Object,
};

const MissedOepCutoffWarning = (props: Props) => {
  const { isFFM, onExchange, using } = props;
  return isFFM ? (
    <StyledDeadlineTranslate
      path={`${DEADLINE_TRANSLATE_PREFIX}.missedCutoffOnExchange`}
      using={using} />
  ) : (
    <React.Fragment>
      <StyledDeadlineTranslate path={`${DEADLINE_TRANSLATE_PREFIX}.justMissedCutoff`} />
      <StyledDeadlineTranslate path={`${DEADLINE_TRANSLATE_PREFIX}.oepClosed`}
        using={using} />
      <StyledDeadlineTranslate
        path={`${DEADLINE_TRANSLATE_PREFIX}.${
          onExchange ? 'missedOepCutoffOnExchange' : 'missedOepCutoffOffExchange'
        }`}
        using={using} />
      <StyledDeadlineTranslate path={`${DEADLINE_TRANSLATE_PREFIX}.checkSepEligibilty`} />
    </React.Fragment>
  );
};

export default MissedOepCutoffWarning;
